import { render, staticRenderFns } from "./yk.vue?vue&type=template&id=249ac70e&scoped=true&"
import script from "./yk.vue?vue&type=script&lang=js&"
export * from "./yk.vue?vue&type=script&lang=js&"
import style0 from "./yk.vue?vue&type=style&index=0&id=249ac70e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249ac70e",
  null
  
)

export default component.exports